module.exports = __webpack_public_path__ + "media/applicants/icon-online@2x-cb415da1.png";